<template>
  <div>
    <div v-show="isLoading">
      <div class="Zoom__loading_area" style="margin-top:20%">
        <div class="Loading__anime">
          <div />
        </div>
        <p class="Zoom__loading_tx">
          少々お待ち下さい･･･
        </p>
      </div>
    </div>
    <div v-show="!isLoading">
      <header class="Header">
        <div class="Header__inner">
          <router-link class="Header_menu__logo" to="/">
            <img class="Header_menu__logo_img" src="assets/img/melon_logo_blue.png" alt="MELON ONLINE">
          </router-link>
          <div v-show="isMobile" class="Heade__main ft_en">
            <div class="Header__menu_area">
              <RouterLink
                v-for="(menu,key) of headerMenus"
                :key="key"
                :class="`Header__menu_link ${menu.menuClass} ${setActiveMenu(menu)} ft_en`"
                :to="menu.path"
              >
                {{ menu.name }}
              </RouterLink>
            </div>
          </div>
        </div>
      </header>
      <div v-if="checkClass" class="contents contents--pt">
        <div class="Zoom _min-h">
          <div class="inner">
            <div class="Zoom__class_area">
              <div class="Zoom__class_box">
                <div class="Zoom__class_box_head">
                  クラス時間
                </div>
                <div class="Zoom__class_box_tx">
                  {{ showDate(zoomDetail.date) }} &#040;{{ showDay(zoomDetail.date) }}&#041;
                  <span class="_mg-l1em"> {{ zoomDetail.learning_time }}～</span>
                </div>
              </div>
              <div class="Zoom__class_box">
                <div class="Zoom__class_box_head">
                  クラス名
                </div>
                <div class="Zoom__class_box_tx" style="text-transform:capitalize;">
                  {{ zoomDetail.master_program_category ? zoomDetail.master_program_category.name : '' }}
                </div>
              </div>
              <div class="Zoom__class_box">
                <div class="Zoom__class_box_head">
                  インストラクター名
                </div>
                <div class="Zoom__class_box_tx">
                  {{ zoomDetail.master_instructor ? zoomDetail.master_instructor.name : '' }}
                </div>
              </div>
            </div>
            <div class="Zoom__loading_area">
              <div class="Loading__anime">
                <div />
              </div>
              <p class="Zoom__loading_tx">
                Zoomを立ち上げています･･･
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="contents contents--pt">
        <section class="section--pt-xlg section--sp-pt-lg _pb-sm">
          <div class="Card__class_archives _error">
            <div class="Error__box_class_tv inner">
              <div class="Error__box Error__box_class">
                <p class="Error__box_tx" style="font-size: 125%;">
                  開催中のクラスはありません。
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import scheduleService from '@/services/scheduleService'
import moment from 'moment'
import zoomLogService from '@/services/zoomLogService'

export default {
  name: 'ZoomSetup',
  data() {
    return {
      zoomDetail: {},
      data: [],
      checkClass: false,
      headerMenus: [],
      isMobile: false,
      isLoading: true
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  updated() {
    this.isMobile
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    this.getZoomDetail()
  },
  methods: {
    async getZoomDetail() {
      this.headerMenus = this.getHeaderMenus()
      const response = await scheduleService.zoom()
      this.zoomDetail = response.data
      if (this.zoomDetail) {
        this.checkClass = true
        this.zoomDetail.date = moment(this.zoomDetail.date).local()
        this.zoomDetail.learning_time = this.zoomDetail.date.format('HH:mm')
        const data = {
          learning_time: this.zoomDetail.time,
          class_id: this.zoomDetail.id,
          date: moment(this.zoomDetail.date).format('Y-M-DD')
        }
        await zoomLogService.add(data)
        const zoomSetting = await scheduleService.zoomSetting()
        let urlZoom = 'https://us04web.zoom.us/j/79946795301?pwd=NXA3T0h4Z0VRSk5ENjRPMW8yQVFPQT09'
        if (zoomSetting.data) {
          urlZoom = zoomSetting.data.zoom_url
        }
        setTimeout(() => {
          window.location.href = urlZoom
        }, 600)
      }
      this.isLoading = false
    },
    showDate(date) {
      if (date !== null) {
        return moment(date).format('M.DD')
      }
    },
    showDay(date) {
      if (date !== null) {
        return moment(date).format('ddd')
      }
    },
    getHeaderMenus() {
      return [
        {
          path: '/',
          name: 'Home',
          menuClass: 'Header__menu_link_home',
          is_internal: true
        },
        {
          path: '/zoom-setup',
          name: 'Class',
          menuClass: 'Header__menu_link_class Header__menu_link--class',
          is_internal: true
        },
        {
          path: '/melon-tv',
          name: 'MELON TV',
          menuClass: 'Header__menu_link_tv Header__menu_link--tv',
          is_internal: true
        },
        {
          path: '/log',
          name: 'Log',
          menuClass: 'Header__menu_link_log Header__menu_link--log',
          is_internal: true
        }
      ]
    },
    setActiveMenu(menu) {
      return this.$route.path === menu.path ? 'Header__menu_link--active' : ''
    },
    handleResize() {
      this.width = window.innerWidth
      this.height = window.innerHeight
      if (this.width <= 767) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    }
  }
}
</script>
